import React, { useState } from 'react'
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom'
import { styled, ThemeProvider } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import MuiDrawer from '@mui/material/Drawer'
import Box from '@mui/material/Box'
import MuiAppBar from '@mui/material/AppBar'
import Toolbar from '@mui/material/Toolbar'
import List from '@mui/material/List'
import Typography from '@mui/material/Typography'
import Divider from '@mui/material/Divider'
import IconButton from '@mui/material/IconButton'
import Container from '@mui/material/Container'
import Grid from '@mui/material/Grid'
import MenuIcon from '@mui/icons-material/Menu'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import LogoutIcon from '@mui/icons-material/Logout'

import Sidebar from './component/Sidebar'
import Login from './pages/auth/Login'
import Home from './pages/home/Home'
import AppCountryMetrics from './pages/appGeoAnalytics/AppCountryMetrics'
import OnboardingFunnel from './pages/onboardingFunnel/OnboardingFunnel'
import GoogleAds from './pages/googleAds/GoogleAds'
import Payments from './pages/payments/Payments'
import Payment from './pages/payments/Payment'
import OrderShippings from './pages/orderShippings/OrderShippings'
import Products from './pages/products/Products'
import Product from './pages/products/Product'
import NewProduct from './pages/products/NewProduct'
import ProductQnas from './pages/productQnas/Qnas'
import ProductQna from './pages/productQnas/Qna'
import BestProducts from './pages/bestProducts/BestProducts'
import HomeTop10Promotions from './pages/homeTop10Promotions/HomeTop10Promotions'
import Animals from './pages/animals/Animals'
import Animal from './pages/animals/Animal'
import NewAnimal from './pages/animals/NewAnimal'
import AnimalPackages from './pages/animalPackages/AnimalPackages'
import AnimalPackage from './pages/animalPackages/AnimalPackage'
import NewAnimalPackage from './pages/animalPackages/NewAnimalPackage'
import AnimalPackageCodes from './pages/animalPackages/AnimalPackageCodes'
import PointCouponCodes from './pages/pointCoupons/PointCouponCodes'
import Records from './pages/records/Records'
import Record from './pages/records/Record'
import Sports from './pages/sports/Sports'
import Sport from './pages/sports/Sport'
import NewSport from './pages/sports/NewSport'
import AppUsers from './pages/appUsers/AppUsers'
import AppUser from './pages/appUsers/AppUser'
import AppReviews from './pages/appReviews/AppReviews'
import AppReview from './pages/appReviews/AppReview'
import AppSportsReviews from './pages/appSportsReviews/AppSportsReviews'
import AppSportsReview from './pages/appSportsReviews/AppSportsReview'
import NewAppSportsReview from './pages/appSportsReviews/NewAppSportsReview'
import AppBlocks from './pages/appBlocks/AppBlocks'
import AppBlock from './pages/appBlocks/AppBlock'
import AppBanners from './pages/appBanners/AppBanners'
import AppBanner from './pages/appBanners/AppBanner'
import NewAppBanner from './pages/appBanners/NewAppBanner'
import AppCountrys from './pages/appCountrys/AppCountrys'
import AppCountry from './pages/appCountrys/AppCountry'
import NewAppCountry from './pages/appCountrys/NewAppCountry'
import AppRunnings from './pages/appRunnings/AppRunnings'
import AppRunning from './pages/appRunnings/AppRunning'
import AppTerritorySkins from './pages/appTerritorySkins/AppTerritorySkins'
import AppTerritorySkin from './pages/appTerritorySkins/AppTerritorySkin'
import NewAppTerritorySkin from './pages/appTerritorySkins/NewAppTerritorySkin'
import AppNotices from './pages/appNotices/AppNotices'
import AppNotice from './pages/appNotices/AppNotice'
import NewAppNotice from './pages/appNotices/NewAppNotice'
import AppSeasons from './pages/appSeasons/AppSeasons'
import AppSeason from './pages/appSeasons/AppSeason'
import NewAppSeason from './pages/appSeasons/NewAppSeason'
import AppRankingBanners from './pages/appRankingBanners/AppRankingBanners'
import AppRankingBanner from './pages/appRankingBanners/AppRankingBanner'
import NewAppRankingBanner from './pages/appRankingBanners/NewAppRankingBanner'
import AppRankingRewards from './pages/appRankingBanners/AppRankingRewards'
import AppTabPromotions from './pages/appTabPromotions/AppTabPromotions'
import AppTabPromotion from './pages/appTabPromotions/AppTabPromotion'
import NewAppTabPromotion from './pages/appTabPromotions/NewAppTabPromotion'
import CoupangRunningOwnedProducts from './pages/coupangRunningOwnedProducts/CoupangRunningOwnedProducts'
import AppPopups from './pages/appPopups/AppPopups'
import AppPopup from './pages/appPopups/AppPopup'
import NewAppPopup from './pages/appPopups/NewAppPopup'
import AppPushs from './pages/appPushs/AppPushs'
import AppPush from './pages/appPushs/AppPush'
import NewAppPush from './pages/appPushs/NewAppPush'
import AppCoupangBanners from './pages/appCoupangBanners/AppCoupangBanners'
import AppCoupangBanner from './pages/appCoupangBanners/AppCoupangBanner'
import NewAppCoupangBanner from './pages/appCoupangBanners/NewAppCoupangBanner'
import Banners from './pages/banners/Banners'
import Banner from './pages/banners/Banner'
import NewBanner from './pages/banners/NewBanner'
import BannerV2s from './pages/bannerV2s/BannerV2s'
import Notices from './pages/notices/Notices'
import Notice from './pages/notices/Notice'
import NewNotice from './pages/notices/NewNotice'
import AppQnas from './pages/appQnas/AppQnas'
import AppQna from './pages/appQnas/AppQna'
import AppMeetWes from './pages/appMeetWes/AppMeetWes'
import AppMeetWe from './pages/appMeetWes/AppMeetWe'
import AppMeetWeInfos from './pages/appMeetWeInfos/AppMeetWeInfos'
import AppMeetWeInfo from './pages/appMeetWeInfos/AppMeetWeInfo'
import NewAppMeetWeInfo from './pages/appMeetWeInfos/NewAppMeetWeInfo'
import AppVersions from './pages/appVersions/AppVersions'
import AppCompanys from './pages/appCompanys/AppCompanys'
import AppCompany from './pages/appCompanys/AppCompany'
import NewAppCompany from './pages/appCompanys/NewAppCompany'
import AppCompanyDomains from './pages/appCompanyDomains/AppCompanyDomains'
import AppCompanyDomain from './pages/appCompanyDomains/AppCompanyDomain'
import NewAppCompanyDomain from './pages/appCompanyDomains/NewAppCompanyDomain'
import AppCompanyContacts from './pages/appCompanyContacts/AppCompanyContacts'
import AppCompanyContact from './pages/appCompanyContacts/AppCompanyContact'
import AppCompanyContactImages from './pages/appCompanyContactImages/AppCompanyContactImages'
import AppCompanyContactImage from './pages/appCompanyContactImages/AppCompanyContactImage'
import NewAppCompanyContactImage from './pages/appCompanyContactImages/NewAppCompanyContactImage'
import AppGifticons from './pages/appGifticons/AppGifticons'
import AppGifticon from './pages/appGifticons/AppGifticon'
import AppGifticonCompanyOrders from './pages/appGifticonCompanyOrders/AppGifticonCompanyOrders'
import AppGifticonCompanyOrder from './pages/appGifticonCompanyOrders/AppGifticonCompanyOrder'
import AppGifticonCompanyOrderRefunds from './pages/appGifticonCompanyOrderRefunds/AppGifticonCompanyOrderRefunds'
import AppGifticonCompanyOrderRefund from './pages/appGifticonCompanyOrderRefunds/AppGifticonCompanyOrderRefund'
import AppPartners from './pages/appPartners/AppPartners'
import AppPartner from './pages/appPartners/AppPartner'
import NewAppPartner from './pages/appPartners/NewAppPartner'
import AppMarketings from './pages/appMarketings/AppMarketings'
import AppMarketing from './pages/appMarketings/AppMarketing'
import NewAppMarketing from './pages/appMarketings/NewAppMarketing'
import AppReviewEvents from './pages/appReviewEvents/AppReviewEvents'
import AppReviewEvent from './pages/appReviewEvents/AppReviewEvent'
import AppGifticonCategorys from './pages/appGifticonCategorys/AppGifticonCategorys'
import AppGifticonExchanges from './pages/appGifticonExchanges/AppGifticonExchanges'
import Donations from './pages/donations/Donations'
import Donation from './pages/donations/Donation'
import NewDonation from './pages/donations/NewDonation'
import DonationExchanges from './pages/donationExchanges/DonationExchanges'
import MedalPortfolios from './pages/medalPortfolios/MedalPortfolios'
import MedalProducts from './pages/medalProducts/MedalProducts'
import MedalProductSpecs from './pages/medalProductSpecs/MedalProductSpecs'
import MedalProductOptions from './pages/medalProductOptions/MedalProductOptions'
import MedalOrders from './pages/medalOrders/MedalOrders'
import MedalOrder from './pages/medalOrders/MedalOrder'
import MeetAddRequests from './pages/meetAddRequests/MeetAddRequests'
import MeetAddRequest from './pages/meetAddRequests/MeetAddRequest'
import Settings from './pages/settings/Settings'
import Memberships from './pages/memberships/Memberships'
import Membership from './pages/memberships/Membership'
import MembershipReconciliation from './pages/memberships/MembershipReconciliation'
import MembershipFunnel from './pages/membershipFunnel/MembershipFunnel'

import Faqs from './pages/faqs/Faqs'
import Faq from './pages/faqs/Faq'
import NewFaq from './pages/faqs/NewFaq'
import Qnas from './pages/qnas/Qnas'
import Qna from './pages/qnas/Qna'
import Admins from './pages/admins/Admins'
import Admin from './pages/admins/Admin'
import NewAdmin from './pages/admins/NewAdmin'
import Password from './pages/password/Password'
import ShippingFees from './pages/shippingFee/ShippingFees'
import ShippingFee from './pages/shippingFee/ShippingFee'

import OrderClaims from './pages/orderClaims/OrderClaims'
import OrderClaim from './pages/orderClaims/OrderClaim'

import AppAccessRules from './pages/appAccessRules/AppAccessRules'
import AppAccessRule from './pages/appAccessRules/AppAccessRule'
import NewAppAccessRule from './pages/appAccessRules/NewAppAccessRule'

import PrivateRoute from './PrivateRoute'
import API from './component/Axios'
import adminTheme from './theme/adminTheme'
import { clearAdminSession, getAdminSession, isAdminAuthenticated, isCountryAnalyticsOnlySession } from './utils/sessionUtils'

import './App.css'

const drawerWidth = 220

const AppBar = styled(MuiAppBar, { shouldForwardProp: (prop) => prop !== 'open', }) (({ theme, open }) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}))

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
        '& .MuiDrawer-paper': {
            // position: 'relative',
            whiteSpace: 'nowrap',
            width: drawerWidth,
            transition: theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            }),
            boxSizing: 'border-box',
            ...(!open && {
                overflowX: 'hidden',
                transition: theme.transitions.create('width', {
                    easing: theme.transitions.easing.sharp,
                    duration: theme.transitions.duration.leavingScreen,
                }),
                width: theme.spacing(7),
                [theme.breakpoints.up('sm')]: {
                    width: theme.spacing(9),
                },
            }),
        },
    }),
)

export default function App(props) {
    const [auth, setAuth] = useState(isAdminAuthenticated())
    const [open, setOpen] = useState(true)
    const { adminId, role, accessMode } = getAdminSession()
    const countryAnalyticsOnly = isCountryAnalyticsOnlySession()

    const toggleDrawer = () => {
        setOpen(!open)
    }

    const handleLogout = async () => {
        try {
            await API.post('/api/v1/admin/auth/logout', {})
        } catch (_error) {
            // 서버 세션이 이미 정리된 경우에도 로컬 세션 종료는 보장합니다.
        } finally {
            clearAdminSession()
            setAuth(false)
            window.location.href = '/login'
        }
    }

    return (
        // <DashboardContent />
        <Router>
            <ThemeProvider theme={adminTheme}>
                <Box sx={{ display: 'flex' }}>
                    <CssBaseline />
                    {/* 탑바 */}
                    <AppBar position="absolute" open={open}>
                        <Toolbar
                            sx={{
                                minHeight: 56,
                                pr: '24px', // keep right padding when drawer closed
                                alignItems: 'center',
                            }}
                        >
                            <IconButton
                                edge="start"
                                color="inherit"
                                aria-label="open drawer"
                                onClick={toggleDrawer}
                                sx={{
                                    mr: 2,
                                    ...(open && { display: 'none' }),
                                }}
                            >
                                <MenuIcon />
                            </IconButton>
                            <Typography
                                component="h1"
                                variant="h6"
                                color="inherit"
                                noWrap
                                sx={{
                                    flexGrow: 1,
                                    display: 'flex',
                                    alignItems: 'center',
                                    mb: 0,
                                    minHeight: 40,
                                    lineHeight: 1,
                                }}
                            >
                                관리자 페이지
                                {process.env.REACT_APP_ENV === 'dev' && (
                                    <Box component="span" sx={{ color: 'warning.light', ml: 1, fontWeight: 700, lineHeight: 1 }}>
                                        (DEV SERVER)
                                    </Box>
                                )}
                            </Typography>
                            {/* <IconButton color="inherit">
                                <Badge badgeContent={4} color="secondary"><NotificationsIcon /></Badge>
                            </IconButton> */}
                            {auth && (
                                <IconButton
                                    onClick={handleLogout}
                                    color="inherit"
                                    sx={{
                                        gap: 0.5,
                                        height: 40,
                                        px: 1,
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                    }}
                                >
                                    <LogoutIcon sx={{ fontSize: 20 }} />
                                    <Typography
                                        component="span"
                                        color="inherit"
                                        sx={{
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            fontSize: 14,
                                            fontWeight: 700,
                                            lineHeight: 1,
                                        }}
                                    >
                                        Logout
                                    </Typography>
                                </IconButton>
                            )}
                        </Toolbar>
                    </AppBar>

                    {/* 사이드바 */}
                    <Drawer variant="permanent" open={open}>
                        <Toolbar
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'flex-end',
                                px: [1],
                            }}
                        >
                            <IconButton onClick={toggleDrawer}>
                                <ChevronLeftIcon />
                            </IconButton>
                        </Toolbar>
                        <Divider />
                        <List>
                            <Sidebar auth={auth} role={role} adminId={adminId} accessMode={accessMode}/>
                        </List>
                    </Drawer>

                    {/* 메인 */}
                    <Box
                        component="main"
                        sx={{
                        backgroundColor: (theme) =>
                            theme.palette.mode === 'light'
                            ? theme.palette.grey[100]
                            : theme.palette.grey[900],
                        flexGrow: 1,
                        height: '100vh',
                        overflow: 'auto',
                        ...(open ? { paddingLeft: '224px' } : { paddingLeft: '74px' })
                        }}
                    >
                        <Toolbar />
                        <Container maxWidth="xl" sx={{ mt: 4, mb: 2 }} >
                            <Grid container spacing={3}>
                                <Switch>
                                    <Route path="/login"><Login setAuth={setAuth} setOpen={setOpen}/></Route>
                                    {countryAnalyticsOnly ? (
                                        <>
                                            <PrivateRoute exact path="/" component={AppCountryMetrics}/>
                                            <PrivateRoute path="/appGeoAnalytics" component={AppCountryMetrics}/>
                                            <PrivateRoute path="/appCountrySignups" component={AppCountryMetrics}/>
                                            <Redirect to="/appGeoAnalytics" />
                                        </>
                                    ) : (
                                        <>
                                    <PrivateRoute exact path="/" component={Home}/>
                                    <PrivateRoute path="/appGeoAnalytics" component={AppCountryMetrics}/>
                                    <PrivateRoute path="/appCountrySignups" component={AppCountryMetrics}/>
                                    <PrivateRoute path="/onboardingFunnel" component={OnboardingFunnel}/>
                                    <PrivateRoute path="/googleAds" component={GoogleAds}/>

                                    <PrivateRoute path="/users" component={AppUsers}/>
                                    <PrivateRoute path="/user/:userId" component={AppUser}/>

                                    <PrivateRoute path="/payments" component={Payments}/>
                                    <PrivateRoute path="/payment/:orderDetailId" component={Payment}/>

                                    <PrivateRoute path="/memberships" component={Memberships}/>
                                    <PrivateRoute path="/membership-reconciliation" component={MembershipReconciliation}/>
                                    <PrivateRoute path="/membership-funnel" component={MembershipFunnel}/>
                                    <PrivateRoute path="/membership/:membershipId" component={Membership}/>

                                    <PrivateRoute path="/orderShippings" component={OrderShippings}/>

                                    <PrivateRoute path="/products" component={Products}/>
                                    <PrivateRoute path="/product/:productId" component={Product}/>
                                    <PrivateRoute path="/new-product" component={NewProduct}/>

                                    <PrivateRoute path="/productQnas" component={ProductQnas}/>
                                    <PrivateRoute path="/productQna/:productQnaId" component={ProductQna}/>

                                    <PrivateRoute path="/best" component={BestProducts}/>
                                    <PrivateRoute path="/homeTop10Promotions" component={HomeTop10Promotions}/>

                                    <PrivateRoute path="/animal-packages" component={AnimalPackages}/>
                                    <PrivateRoute path="/animal-package/:productId" component={AnimalPackage}/>
                                    <PrivateRoute path="/new-animal-package" component={NewAnimalPackage}/>
                                    <PrivateRoute path="/animal-package-codes" component={AnimalPackageCodes}/>
                                    <PrivateRoute path="/point-coupon-codes" component={PointCouponCodes}/>
                                    <PrivateRoute path="/animals" component={Animals}/>
                                    <PrivateRoute path="/animal/:productId" component={Animal}/>
                                    <PrivateRoute path="/new-animal" component={NewAnimal}/>

                                    <PrivateRoute path="/new-records" component={Records}/>
                                    <PrivateRoute path="/new-record/:recordId" component={Record}/>

                                    <PrivateRoute path="/sports" component={Sports}/>
                                    <PrivateRoute path="/sport/:sportsId" component={Sport}/>
                                    <PrivateRoute path="/new-sport" component={NewSport}/>

                                    <PrivateRoute path="/appUsers" component={AppUsers}/>
                                    <PrivateRoute path="/appUser/:userId" component={AppUser}/>

                                    <PrivateRoute path="/appReviews" component={AppReviews}/>
                                    <PrivateRoute path="/appReview/:sportsReviewId" component={AppReview}/>

                                    <PrivateRoute path="/appSportsReviews" component={AppSportsReviews}/>
                                    <PrivateRoute path="/appSportsReview/:sportsReviewId" component={AppSportsReview}/>
                                    <PrivateRoute path="/new-appSportsReview" component={NewAppSportsReview}/>
                                    
                                    <PrivateRoute path="/appBlocks" component={AppBlocks}/>
                                    <PrivateRoute path="/appBlock/:blockId" component={AppBlock}/>

                                    <PrivateRoute path="/appBanners" component={AppBanners}/>
                                    <PrivateRoute path="/appBanner/:bannerId" component={AppBanner}/>
                                    <PrivateRoute path="/new-appBanner" component={NewAppBanner}/>
                                    
                                    <PrivateRoute path="/countrys" component={AppCountrys}/>
                                    <PrivateRoute path="/country/:countryId" component={AppCountry}/>
                                    <PrivateRoute path="/new-country" component={NewAppCountry}/>

                                    <PrivateRoute path="/appRunnings" component={AppRunnings}/>
                                    <PrivateRoute path="/appRunning/:userRunId" component={AppRunning}/>
                                    <PrivateRoute path="/appTerritorySkins" component={AppTerritorySkins}/>
                                    <PrivateRoute path="/appTerritorySkin/:type/:territorySkinId" component={AppTerritorySkin}/>
                                    <PrivateRoute path="/new-appTerritorySkin" component={NewAppTerritorySkin}/>

                                    <PrivateRoute path="/appNotices" component={AppNotices}/>
                                    <PrivateRoute path="/appNotice/:noticeId" component={AppNotice}/>
                                    <PrivateRoute path="/new-appNotice" component={NewAppNotice}/>

                                    <PrivateRoute path="/appSeasons" component={AppSeasons}/>
                                    <PrivateRoute path="/appSeason/:seasonId" component={AppSeason}/>
                                    <PrivateRoute path="/new-appSeason" component={NewAppSeason}/>

                                    <PrivateRoute path="/appPopups" component={AppPopups}/>
                                    <PrivateRoute path="/appPopup/:popupId" component={AppPopup}/>
                                    <PrivateRoute path="/new-appPopup" component={NewAppPopup}/>

                                    <PrivateRoute path="/appPushs" component={AppPushs}/>
                                    <PrivateRoute path="/appPush/:pushHistoryId" component={AppPush}/>
                                    <PrivateRoute path="/new-appPush" component={NewAppPush}/>

                                    <PrivateRoute path="/appRankingBanners" component={AppRankingBanners}/>
                                    <PrivateRoute path="/appRankingBanner/:rankingBannerId" component={AppRankingBanner}/>
                                    <PrivateRoute path="/new-appRankingBanner" component={NewAppRankingBanner}/>
                                    <PrivateRoute path="/appRankingRewards" component={AppRankingRewards}/>

                                    <PrivateRoute path="/appTabPromotions" component={AppTabPromotions}/>
                                    <PrivateRoute path="/appTabPromotion/:promotionId" component={AppTabPromotion}/>
                                    <PrivateRoute path="/new-appTabPromotion" component={NewAppTabPromotion}/>
                                    <PrivateRoute path="/coupangRunningOwnedProducts" component={CoupangRunningOwnedProducts}/>

                                    <PrivateRoute path="/appQnas" component={AppQnas}/>
                                    <PrivateRoute path="/appQna/:qnaId" component={AppQna}/>

                                    <PrivateRoute path="/appMeetWes" component={AppMeetWes}/>
                                    <PrivateRoute path="/appMeetWe/:meetId" component={AppMeetWe}/>

                                    <PrivateRoute path="/appInfoMeetWes" component={AppMeetWeInfos}/>
                                    <PrivateRoute path="/appInfoMeetWe/:meetWeInfoId" component={AppMeetWeInfo}/>
                                    <PrivateRoute path="/new-appInfoMeetWe" component={NewAppMeetWeInfo}/>

                                    <PrivateRoute path="/appCoupangBanners" component={AppCoupangBanners}/>
                                    <PrivateRoute path="/appCoupangBanner/:coupangBannerId" component={AppCoupangBanner}/>
                                    <PrivateRoute path="/new-appCoupangBanner" component={NewAppCoupangBanner}/>

                                    <PrivateRoute path="/appVersions" component={AppVersions}/>

                                    <PrivateRoute path="/appCompanys" component={AppCompanys}/>
                                    <PrivateRoute path="/appCompany/:companyId" component={AppCompany}/>
                                    <PrivateRoute path="/new-appCompany" component={NewAppCompany}/>

                                    <PrivateRoute path="/appCompanyDomains" component={AppCompanyDomains}/>
                                    <PrivateRoute path="/appCompanyDomain/:companyDomainId" component={AppCompanyDomain}/>
                                    <PrivateRoute path="/new-appCompanyDomain" component={NewAppCompanyDomain}/>

                                    <PrivateRoute path="/appCompanyContacts" component={AppCompanyContacts}/>
                                    <PrivateRoute path="/appCompanyContact/:companyContactId" component={AppCompanyContact}/>

                                    <PrivateRoute path="/appCompanyContactImages" component={AppCompanyContactImages}/>
                                    <PrivateRoute path="/appCompanyContactImage/:companyContactImageId" component={AppCompanyContactImage}/>
                                    <PrivateRoute path="/new-appCompanyContactImage" component={NewAppCompanyContactImage}/>

                                    <PrivateRoute path="/appGifticons" component={AppGifticons}/>
                                    <PrivateRoute path="/appGifticon/:goodsCode" component={AppGifticon}/>

                                    <PrivateRoute path="/appGifticonCompanyOrders" component={AppGifticonCompanyOrders}/>
                                    <PrivateRoute path="/appGifticonCompanyOrder/:paymentId" component={AppGifticonCompanyOrder}/>

                                    <PrivateRoute path="/appGifticonCompanyOrderRefunds" component={AppGifticonCompanyOrderRefunds}/>
                                    <PrivateRoute path="/appGifticonCompanyOrderRefund/:orderItemRefundId" component={AppGifticonCompanyOrderRefund}/>

                                    <PrivateRoute path="/appPartners" component={AppPartners}/>
                                    <PrivateRoute path="/appPartner/:partnerId" component={AppPartner}/>
                                    <PrivateRoute path="/new-appPartner" component={NewAppPartner}/>


                                    <PrivateRoute path="/appMarketings" component={AppMarketings}/>
                                    <PrivateRoute path="/appMarketing/:marketingId" component={AppMarketing}/>
                                    <PrivateRoute path="/new-appMarketing" component={NewAppMarketing}/>

                                    <PrivateRoute path="/appReviewEvents" component={AppReviewEvents}/>
                                    <PrivateRoute path="/appReviewEvent/:reviewEventId" component={AppReviewEvent}/>

                                    <PrivateRoute path="/appGifticonCategorys" component={AppGifticonCategorys}/>
                                    <PrivateRoute path="/appGifticonExchanges" component={AppGifticonExchanges}/>
                                    <PrivateRoute path="/donations" component={Donations}/>
                                    <PrivateRoute path="/donation/:donationProductId" component={Donation}/>
                                    <PrivateRoute path="/new-donation" component={NewDonation}/>
                                    <PrivateRoute path="/donationExchanges" component={DonationExchanges}/>
                                    
                                    
                                    <PrivateRoute path="/banners" component={Banners}/>
                                    <PrivateRoute path="/banner/:bannerId" component={Banner}/>
                                    <PrivateRoute path="/new-banner" component={NewBanner}/>
                                    
                                    <PrivateRoute path="/bannerV2" component={BannerV2s}/>

                                    <PrivateRoute path="/notices" component={Notices}/>
                                    <PrivateRoute path="/notice/:noticeId" component={Notice}/>
                                    <PrivateRoute path="/new-notice" component={NewNotice}/>
                                    
                                    <PrivateRoute path="/faqs" component={Faqs}/>
                                    <PrivateRoute path="/faq/:faqId" component={Faq}/>
                                    <PrivateRoute path="/new-faq" component={NewFaq}/>
                                    
                                    <PrivateRoute path="/qnas" component={Qnas}/>
                                    <PrivateRoute path="/qna/:qnaId" component={Qna}/>
                                    
                                    <PrivateRoute path="/admins" component={Admins}/>
                                    <PrivateRoute path="/admin/:adminId" component={Admin}/>
                                    <PrivateRoute path="/new-admin" component={NewAdmin}/>

                                    <PrivateRoute path="/password" component={Password}/>

                                    <PrivateRoute path="/shippingFees" component={ShippingFees}/>
                                    <PrivateRoute path="/shippingFee/:adminId" component={ShippingFee}/>

                                    <PrivateRoute path="/medalPortfolios" component={MedalPortfolios}/>
                                    <PrivateRoute path="/medalProducts" component={MedalProducts}/>
                                    <PrivateRoute path="/medalProductSpecs" component={MedalProductSpecs}/>
                                    <PrivateRoute path="/medalProductOptions" component={MedalProductOptions}/>
                                    <PrivateRoute path="/medalOrders" component={MedalOrders}/>
                                    <PrivateRoute path="/medalOrder/:medalOrderId" component={MedalOrder}/>

                                    <PrivateRoute path="/meetAddRequests" component={MeetAddRequests}/>
                                    <PrivateRoute path="/meetAddRequest/:meetAddRequestId" component={MeetAddRequest}/>

                                    <PrivateRoute path="/orderClaims" component={OrderClaims}/>
                                    <PrivateRoute path="/orderClaim/:orderClaimId" component={OrderClaim}/>

                                    <PrivateRoute path="/appAccessRules" component={AppAccessRules}/>
                                    <PrivateRoute path="/appAccessRule/:appAccessRuleId" component={AppAccessRule}/>
                                    <PrivateRoute path="/new-appAccessRule" component={NewAppAccessRule}/>

                                    <PrivateRoute path="/settings" component={Settings}/>
                                        </>
                                    )}
                                    
                                </Switch>
                            </Grid>

                        </Container>
                    </Box>
                </Box>
            </ThemeProvider>
        </Router>
    )
}
